import {
    Alert,
    InputControl,
    Loading,
    Picker,
    Spacer,
    StyleFunction,
    useThemedStyle,
} from "@venuepos/react-common";
import {
    GQFiskalyTaxPayerLegal,
    GQFiskalyTaxPayerNatural,
    GQFiskalyTaxPayerType,
    useGetFiskalyTaxPayerQuery,
} from "graphql-sdk";
import { useTranslation } from "locales";
import { useState } from "react";
import React, { View } from "react-native";
import { Divider } from "react-native-paper";
import { LegalTaxPayerWidget } from "./legal-person";
import { NaturalTaxPayerWidget } from "./natural-person";

export function FiskalyTaxPayerTab() {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);
    const { data, loading, error } = useGetFiskalyTaxPayerQuery();

    const [taxPayerType, setTaxPayerType] =
        useState<GQFiskalyTaxPayerType | null>(data?.getFiskalyTaxPayer?.type);

    return (
        <View style={styles.container}>
            {data?.getFiskalyTaxPayer === null ? (
                <>
                    <InputControl>
                        <Picker
                            label={t("backoffice.common.type", "Type")}
                            onValueChange={newValue => {
                                setTaxPayerType(
                                    newValue as GQFiskalyTaxPayerType
                                );
                            }}
                            selectedValue={taxPayerType}
                        >
                            <Picker.Item
                                key="__select__"
                                label={t(
                                    "backoffice.common.select_type",
                                    "Select a type"
                                )}
                                value=""
                            />
                            <Picker.Item
                                key={GQFiskalyTaxPayerType.Legal}
                                value={GQFiskalyTaxPayerType.Legal}
                                label={t(
                                    "backoffice.integration.fiskaly.tax_payer_legal_person",
                                    "Legal Person"
                                )}
                            />
                            <Picker.Item
                                key={GQFiskalyTaxPayerType.Natural}
                                value={GQFiskalyTaxPayerType.Natural}
                                label={t(
                                    "backoffice.integration.fiskaly.tax_payer_natural_person",
                                    "Natural Person"
                                )}
                            />
                        </Picker>
                    </InputControl>
                    <Divider />
                    <Spacer />
                </>
            ) : null}
            {data?.getFiskalyTaxPayer?.type === GQFiskalyTaxPayerType.Legal ||
            taxPayerType === GQFiskalyTaxPayerType.Legal ? (
                <LegalTaxPayerWidget
                    taxPayer={
                        data?.getFiskalyTaxPayer as GQFiskalyTaxPayerLegal
                    }
                />
            ) : null}
            {data?.getFiskalyTaxPayer?.type === GQFiskalyTaxPayerType.Natural ||
            taxPayerType === GQFiskalyTaxPayerType.Natural ? (
                <NaturalTaxPayerWidget
                    taxPayer={
                        data?.getFiskalyTaxPayer as GQFiskalyTaxPayerNatural
                    }
                />
            ) : null}
            {error ? (
                <Alert type="error">
                    {t(
                        "backoffice.error.from_server",
                        "There was an error: {{errorText}}",
                        {
                            errorText: error.message,
                        }
                    )}
                </Alert>
            ) : null}
            {loading ? <Loading /> : null}
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        maxWidth: theme.dimensions.maxFormWidth,
    },
});
